<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
<div class="w-full min-h-screen bg-background flex md:items-center md:justify-center p-4 md:p-[5%]">
  <!-- Card -->
  <div
    class="w-full max-w-[900px] rounded-3xl bg-white flex flex-col md:flex-row overflow-hidden shadow-md min-h-[calc(100vh-2rem)] md:min-h-0"
  >
    <!-- LEFT SIDE -->
    <div
      class="hidden md:flex md:w-1/2 relative items-center justify-center"
      style="background-color: #106eb8"
    >
      <img
        class="absolute inset-0 w-full h-full object-cover opacity-20"
        [src]="
          featureImageUrl()
            ? featureImageUrl()
            : 'https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?q=80&w=2187'
        "
        alt=""
      />
    </div>

    <!-- RIGHT SIDE -->
    <div class="flex md:w-1/2 flex-col px-6 py-8 md:py-[65px] flex-1">
      <div class="w-full max-w-md mx-auto flex flex-col flex-1">
        <!-- ============================= -->
        <!-- SUCCESS -->
        <!-- ============================= -->
        @if (passwordResetSuccess()) {
          <div class="flex flex-col flex-1 text-center">
            <!-- TEXTO ARRIBA -->
            <div>
              <h2 class="text-[24px] font-bold mb-4 mt-2">
                {{ 'SHARED.SIGNIN_RECOVER-PASSWORD.SUCCESS_TITLE' | translate }}
              </h2>

              <p class="text-[14px]">
                {{ 'SHARED.SIGNIN_RECOVER-PASSWORD.SUCCESS_DETAIL' | translate }}
              </p>
            </div>

            <!-- BOTÓN ABAJO -->
            <div class="mt-auto pt-8">
              <lib-custom-button
                [label]="'Ir al inicio de sesión'"
                variant="primary"
                class="w-full cursor-pointer"
                [fullWidth]="true"
                (click)="goToLogin()"
              ></lib-custom-button>
            </div>
          </div>
        } @else {
          <!-- ============================= -->
          <!-- FORM -->
          <!-- ============================= -->

          <form
            [formGroup]="recoverPasswordForm"
            (ngSubmit)="onSubmit()"
            class="flex flex-col flex-1"
          >
            <!-- CONTENIDO SUPERIOR -->
            <div class="flex flex-col flex-1">
              <h2 class="text-[24px] font-bold text-center mb-4 mt-2">
                {{ 'SHARED.SIGNIN_RECOVER-PASSWORD.TITLE' | translate }}
              </h2>

              <p class="text-[14px] text-center mb-6">
                {{ 'SHARED.SIGNIN_RECOVER-PASSWORD.INSTRUCTIONS' | translate }}
              </p>

              <lib-custom-input
                [label]="'SHARED.SIGNIN_RECOVER-PASSWORD.NEW_PASSWORD_LABEL' | translate"
                type="password"
                [placeholder]="
                  'SHARED.SIGNIN_RECOVER-PASSWORD.NEW_PASSWORD_PLACEHOLDER' | translate
                "
                [hint]="'SHARED.SIGNIN_RECOVER-PASSWORD.EMAIL_HINT' | translate"
                name="newPassword"
                formControlName="newPassword"
                class="mb-4"
                iconLeft="fa-solid fa-lock"
              >
              </lib-custom-input>

              <lib-custom-input
                [label]="'SHARED.SIGNIN_RECOVER-PASSWORD.CONFIRM_PASSWORD_LABEL' | translate"
                type="password"
                [placeholder]="
                  'SHARED.SIGNIN_RECOVER-PASSWORD.CONFIRM_PASSWORD_PLACEHOLDER' | translate
                "
                name="confirmPassword"
                formControlName="confirmPassword"
                class="mb-4"
                iconLeft="fa fa-lock"
              >
              </lib-custom-input>

              @if (
                confirmPassword?.errors?.['passwordsMismatch'] &&
                (confirmPassword?.touched || recoverPasswordForm.touched)
              ) {
                <div class="text-error text-[12px] mb-2">
                  {{ 'SHARED.SIGNIN_RECOVER-PASSWORD.ERROR_PASSWORDS_MISMATCH' | translate }}
                </div>
              }
            </div>

            <!-- BOTÓN ABAJO -->
            <div class="mt-auto pt-8">
              <lib-custom-button
                [label]="'SHARED.SIGNIN_RECOVER-PASSWORD.BUTTON' | translate"
                variant="primary"
                type="submit"
                [loading]="loading()"
                [disabled]="recoverPasswordForm.invalid || loading()"
                class="w-full"
                [fullWidth]="true"
              ></lib-custom-button>
            </div>
          </form>
        }
      </div>
    </div>
  </div>
</div>
